'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const{DataSet:DataSet,Timeline:Timeline}=require('vis-timeline');
const Formatters=require('../../../../dist-es6/client/formatters');
const moment=require('pulsar-utils/dist-es6/time/moment');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

ScheduleRowDirective=function(_BaseControllerBacked){_inherits(ScheduleRowDirective,_BaseControllerBacked);function ScheduleRowDirective(){_classCallCheck(this,ScheduleRowDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(ScheduleRowDirective,[{key:'template',get:function()
{return''}},{key:'objectBindings',get:function()

{return['schedule']}},{key:'$inject',get:function()

{return['$scope','$timeout','$element','$animate','timeZoneService','scheduleRowScrollingService']}},{key:'controller',get:function()

{return ScheduleRowController}}]);return ScheduleRowDirective}(BaseControllerBackedDirective);


const ControllerDefaults={
schedule:null,
_initialDrawComplete:!1};


const _windowUpdateOptions={
animation:!1};


const _timelineOptions={
autoResize:!0,
selectable:!1,
stack:!1,
zoomable:!1,
moveable:!1,
horizontalScroll:!1,
verticalScroll:!1,
showMajorLabels:!1,
showMinorLabels:!1,
tooltip:{
followMouse:!1,
overflowMethod:'flip',
delay:35},

margin:{
item:0},

start:new Date(new Date().getTime()-8.64e7*3),
end:new Date(new Date().getTime()+8.64e7*3)};



_.assign(_timelineOptions,{
height:'36px',
showCurrentTime:!1,
timeAxis:{
scale:'day',
step:1}});let




ScheduleRowController=function(){
function ScheduleRowController($scope,$timeout,$element,$animate,timeZoneService,scheduleRowScrollingService){var _this2=this;_classCallCheck(this,ScheduleRowController);
this._$scope=$scope;
this._$timeout=$timeout;
this._$element=$element;
$animate.enabled(!1,$element);

this._timeZoneService=timeZoneService;
this._scheduleRowScrollingService=scheduleRowScrollingService;

this._container=this._$element;
this._dataset=new DataSet;

_.defaults(this,ControllerDefaults);

this._momentWithTimeZoneForTimeline=function(date){return moment(date).tz(_this2._timeZoneService.localTimeZone)};
this.momentWithTimeZoneForTimeline=this._momentWithTimeZoneForTimeline.bind(this);

this._takeoffTimeFormatter=function(takeoffTime){return Formatters.timeInLocale(takeoffTime,_this2._timeZoneService.localTimeZone,!0,!0)};

this._$scope.$on('$destroy',function(){return _.attempt(function(){return _this2._timeline.destroy()})});
this._setupWatchers();

this._debouncedClearTooltip=_.debounce(function(){
fastdom.measure(function(){
const tooltipEl=_this2._container.find('.vis-tooltip');
const visibility=tooltipEl.css('visibility');
if(!tooltipEl||tooltipEl.length===0||!visibility||visibility==='hidden'){
return;
}

fastdom.mutate(function(){
tooltipEl.css('visibility','hidden');
});
});
},1000);
}ScheduleRowController.prototype.

_redraw=function(){var ref=_asyncToGenerator(function*(){
if(!_.exists(this._timeline)){
this._setupTimeline();
}

this._updateWindow();

if(_.exists(this._timeline,'_callbacks.checkRangedItems')){

delete this._timeline._callbacks.checkRangedItems;
}

if(!_.exists(this._updateData)){
return;
}

this._updateData();
this._debouncedClearTooltip();
});function _redraw(){return ref.apply(this,arguments)}return _redraw}();ScheduleRowController.prototype.

_setupWatchers=function _setupWatchers(){var _this3=this;
this._$scope.$watch('controller.schedule',function(newVal,oldVal){return _this3._redraw()});
this._$scope.$on('$destroy',function(){return _.attempt(function(){return _this3._scheduleRowScrollingService.unregisterScheduleRowDirective(_this3)})});
this._scheduleRowScrollingService.registerScheduleRowDirective(this);
};ScheduleRowController.prototype.

_setupTimeline=function _setupTimeline(){var _this4=this;
const timelineOptions=_.defaults({},{
moment:this._momentWithTimeZoneForTimeline,
onInitialDrawComplete:function(){return _this4._initialDrawComplete=!0},
orientation:{
axis:'none',
item:'top'}},

this.currentBounds||{},_timelineOptions);

this._timeline=new Timeline(this._container[0],this._dataset,timelineOptions);
};ScheduleRowController.prototype.

_updateWindow=function _updateWindow(){let newBounds=arguments.length>0&&arguments[0]!==void 0?arguments[0]:this.currentBounds;let options=arguments.length>1&&arguments[1]!==void 0?arguments[1]:_windowUpdateOptions;
if(!_.exists(newBounds)||!_.exists(this._timeline)){
return;
}

const{start:currentStart,end:currentEnd}=this._timeline.getWindow();
if(currentStart.getTime()===newBounds.start.getTime()&&currentEnd.getTime()===newBounds.end.getTime()){
return;
}

this._timeline.setWindow(newBounds.start,newBounds.end,options);
};ScheduleRowController.prototype.

_getTimelineOptions=function _getTimelineOptions(){
return _timelineOptions;
};ScheduleRowController.prototype.

_updateOptions=function _updateOptions(newOptions){
_.merge(this._getTimelineOptions(),newOptions);

if(!this._timeline){
return;
}

this._timeline.setOptions(newOptions);
};ScheduleRowController.prototype.

_updateData=function _updateData(){var _this5=this;
if(!this.schedule){
return;
}

let takeoff;
if(this.schedule.takeoff){
takeoff={
id:'takeoff',
start:this.schedule.takeoff.time,
content:_.toString(Math.floor(this.schedule.takeoff.fatigue)),
type:'point',
title:`Fatigue at ${this._takeoffTimeFormatter(this.schedule.takeoff.time)}`,
className:`takeoff ${this.schedule.takeoff.thresholdStatus}`.trim()};

}

let scenarioBounds;
if(_.exists(this.schedule.scenario)&&this.schedule.scenario.trips&&this.schedule.scenario.trips.length!==0){
scenarioBounds={
id:'scenario-bounds',
start:_.first(this.schedule.scenario.trips).start,
end:_.last(this.schedule.scenario.trips).end,
className:_.compact([
`scenario-bounds`,
!_.exists(this.schedule.selectedFlightIndex)?'surround-pairing':null]).
join(' ')};

}

const flights=[];
if(this.schedule.trips){
this.schedule.trips.forEach(function(trip,index){
const inScenario=!_.exists(trip.tod.thresholdStatus.original);
flights.push({
id:`filght-${index}`,
start:trip.start,
end:trip.end,
title:_formatTripLabel(trip),
className:_.compact([
`flight`,
trip.tod.thresholdStatus.scenario||trip.tod.thresholdStatus.original,
inScenario&&_.exists(_this5.schedule.selectedFlightIndex)&&index===_this5.schedule.selectedFlightIndex?'in-scenario':null]).
join(' ')});

});
}

const localTimeZone=this._timeZoneService.localTimeZone;
const duties=[];
if(this.schedule.duties){
this.schedule.duties.forEach(function(duty,index){
duties.push({
id:`duty-${index}`,
start:duty.start,
end:duty.end,
title:_formatDutyLabel(duty,localTimeZone),
className:_.compact([
`duty`,
duty.peak.scenario?duty.peak.scenario.thresholdStatus:duty.peak.original.thresholdStatus]).
join(' ')});

});
}

const newData=_.compact([scenarioBounds].concat(flights,duties,[takeoff]));

this._timeline.redrawCount=0;
this._timeline.setItems(newData);
};_createClass(ScheduleRowController,[{key:'currentBounds',get:function()

{
return this._scheduleRowScrollingService.axisBounds;
}}],[{key:'DefaultTimelineOptions',get:function()

{
return _timelineOptions;
}}]);return ScheduleRowController}();


function _formatTime(trip,key){
return Formatters.
formatInLocale(trip[key],`${Formatters.TwentyFourHourFormat} (Z)`,trip[key+'Timezone']).
replace(':00)',')');
}

function _formatDutyTime(duty,key,localTimeZone){
return Formatters.timeInLocale(duty[key],localTimeZone,!1,!0);
}

function _formatFatigueForTooltip(thing,fatiguePath,statusPath){
const flooredFatigue=_.toString(Math.floor(_.get(thing,fatiguePath)));
const statusClass=_.get(thing,statusPath);
if(statusClass==='below-threshold'){
return flooredFatigue;
}

return`<strong class="alerting-fatigue ${statusClass}">${flooredFatigue}</strong>`;
}

function _formatFatigueForTripTooltip(trip,kind){
return _formatFatigueForTooltip(trip,`tod.fatigue.${kind}`,`tod.thresholdStatus.${kind}`);
}

function _formatFatigueForDutyTooltip(duty,kind){
return _formatFatigueForTooltip(duty,`peak.${kind}.fatigue`,`peak.${kind}.thresholdStatus`);
}

function _formatFatigueForDutyTooltip(duty,kind){
const flooredFatigue=_.toString(Math.floor(duty.peak[kind].fatigue));
const statusClass=duty.peak[kind].thresholdStatus;
if(statusClass==='below-threshold'){
return flooredFatigue;
}

return`<strong class="alerting-fatigue ${statusClass}">${flooredFatigue}</strong>`;
}

function _formatTripLabel(trip){
const placesAndTimes=`${trip.origin.description} to ${trip.destination.description}<br/>${_formatTime(trip,'start')} - ${_formatTime(trip,'end')}`;
if(!_.exists(trip,'metadata.flight')){
return placesAndTimes;
}

let tripInfo=`<b>${trip.metadata.flight.code} ${trip.metadata.flight.number}</b><br/>${placesAndTimes}<div class="fatigue-break"></div>`;

if(_.exists(trip.tod.fatigue.original)&&!_.exists(trip.tod.fatigue.scenario)){
tripInfo+=`TOD Fatigue: ${_formatFatigueForTripTooltip(trip,'original')}`;
}

if(_.exists(trip.tod.fatigue.scenario)){
tripInfo+=`TOD Fatigue: ${_formatFatigueForTripTooltip(trip,'scenario')}`;

if(_.exists(trip.tod.fatigue.original)&&
Math.floor(trip.tod.fatigue.scenario)!==Math.floor(trip.tod.fatigue.original)){

tripInfo+=` (was ${_formatFatigueForTripTooltip(trip,'original')})`;
}
}

return tripInfo;
}

function _formatDutyLabel(duty,localTimeZone){
let dutyInfo=`<b>${duty.metadata.activity.code}</b><br/>${_formatDutyTime(duty,'start',localTimeZone)} - ${_formatDutyTime(duty,'end',localTimeZone)}<div class="fatigue-break"></div>`;

if(_.exists(duty.peak.original)&&!_.exists(duty.peak.scenario)){
dutyInfo+=`Peak Fatigue: ${_formatFatigueForDutyTooltip(duty,'original')}`;
}

if(_.exists(duty.peak.scenario)){
dutyInfo+=`Peak Fatigue: ${_formatFatigueForDutyTooltip(duty,'scenario')}`;

if(_.exists(duty.peak.original)&&
Math.floor(duty.peak.scenario.fatigue)!==Math.floor(duty.peak.original.fatigue)){

dutyInfo+=` (was ${_formatFatigueForDutyTooltip(duty,'original')})`;
}
}

return dutyInfo;
}

module.exports=ScheduleRowDirective;
module.exports.ScheduleRowDirectiveController=ScheduleRowController;
//# sourceMappingURL=scheduleRowDirective.js.map
